import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { swiper, SwiperComponent, swiperSlide } from 'vue-awesome-swiper';
import { SwiperOptions } from 'swiper';

import { Reward } from '@/models/reward';

@Component({
  name: 'CmgBagOfferModal',
  components: {
    swiper,
    swiperSlide,
  },
})
export default class CmgBagOfferModal extends Vue {
  bagOfferSwiper: SwiperComponent | null = null;
  swiperOptions: SwiperOptions = {
    pagination: {
      el: '.swiper-pagination',
    }
  };

  @Watch('visible', { immediate: true })
  onStateChanged() {
    this.$nextTick(() => {
      const swiperRef = this.$refs.bagOfferSwiper as SwiperComponent | undefined;

      if (swiperRef) {
        this.bagOfferSwiper = swiperRef;

        if (this.prevIndex) {
          this.bagOfferSwiper.swiper?.slideTo(this.prevIndex);
        }
      }
    });
  }

  mounted() {
    this.bagOfferSwiper = this.$refs.bagOfferSwiper as SwiperComponent | null;
  }

  get visible(): boolean {
    return this.$appStore.state.ui.modals.bagOffer.visible;
  }

  get isMobile(): boolean {
    return this.$services.ui.isMobile();
  }

  get modalWidth(): string {
    return this.bagRewards.length > 1 ? '52em' : '30em';
  }

  get bagRewards(): Reward[] {
    return this.$appStore.state.reward.bagRewards;
  }

  get swiperRealIndex(): number | undefined {
    return this.bagOfferSwiper?.swiper?.realIndex;
  }

  get prevIndex(): number | undefined {
    return this.$appStore.state.ui.modals.bagOffer.args?.prevIndex;
  }
  
  goToPreviousSlide() {
    if (!this.bagOfferSwiper || !this.bagOfferSwiper.swiper) {
      return;
    }

    this.bagOfferSwiper.swiper.slidePrev();
  }

  goToNextSlide() {
    if (!this.bagOfferSwiper || !this.bagOfferSwiper.swiper) {
      return;
    }

    this.bagOfferSwiper.swiper.slideNext();
  }

  onClose() {
    this.$services.ui.setModalVisibility('bagOffer', false);
  }
}
